import { MLPVersion, QuantityStepper, QuantityStepperSize, QuantityStepperType } from '@nextgen-web-framework/all';
import { CardType, ProductCardComponent, ProductButtonType, ProductButton } from '../Molecules';
import { PromotionCardPropsTypes } from './types/propsTypes';
import styles from './PromotionCard.module.scss';

const PromotionCard = (props: PromotionCardPropsTypes): JSX.Element => {
  const {
    brandName,
    productName,
    link,
    alt,
    productId,
    productSize,
    derivedAvailabilityStatus,
    productPrice,
    currency,
    productQuantity,
    strikethroughPrice,
    maxCount = 100,
    disabled,
    productCount,
    onQuantityDecrease,
    onQuantityIncrease,
    showZeroAsFree = false,
    isInputQtyButton = false,
    count,
    disablePlusButton,
    disableMinusButton,
    inputChangeHandler,
    minusClickHandler,
    plusClickHandler,
  } = props;

  const qtySelectorButton = (
    <div className={styles['qty-stepper-btn']}>
      <QuantityStepper
        count={count}
        minCount={0}
        maxCount={maxCount}
        type={QuantityStepperType.OUTLINED}
        size={QuantityStepperSize.SMALL}
        mlpVersion={MLPVersion.ONE}
        disabled={disabled}
        disablePlusButton={disablePlusButton}
        disableMinusButton={disableMinusButton}
        step={1}
        inputChangeHandler={inputChangeHandler}
        minusClickHandler={minusClickHandler}
        plusClickHandler={plusClickHandler}
      />
    </div>
  );

  const productButton = (
    <ProductButton
      onQuantityIncrease={onQuantityIncrease}
      onQuantityDecrease={onQuantityDecrease}
      disabled={disabled}
      productCount={productCount}
      maxCount={maxCount}
      id={productId}
      productButtonType={ProductButtonType.PROMOTION_CARD}
    />
  );

  return (
    <>
      <div className={styles['cpw-promotion-drawer-card']}>
        <ProductCardComponent
          brandName={brandName}
          productName={productName}
          link={link}
          alt={alt}
          productId={''}
          productSize={productSize}
          derivedAvailabilityStatus={derivedAvailabilityStatus}
          productPrice={productPrice}
          currency={currency}
          productQuantity={productQuantity}
          cardType={CardType.PROMOTIONCARD}
          strikethroughPrice={strikethroughPrice}
          productCount={productCount}
          id={productId}
          showLinkForProductCard={false}
          showZeroAsFree={showZeroAsFree}
          buttonEle={isInputQtyButton ? qtySelectorButton : productButton}
        />
      </div>
    </>
  );
};

export default PromotionCard;
export type { PromotionCardPropsTypes };
